<template>
    <div class>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-copy"></i> 牌照查看
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label=" isManufacturer?'':'分支机构牌照申请展示' " name="third">
                    <el-form
                        ref="thirdLicenselyform"
                        :model="thirdLicenselyform"
                        class="apply-flex"
                    >
                        <div class="apply-flex">
                            <!-- <p>
                                <el-form-item label="分支机构" prop="applicantOrganizationName">
                                    <el-input
                                        v-model="thirdLicenselyform.applicantOrganizationName"
                                    ></el-input>
                                </el-form-item>
                            </p>-->
                            <p>
                                <el-form-item label="牌照编码" prop="equipmentCode">
                                    <el-input
                                        v-model="thirdLicenselyform.equipmentCode"
                                        style="width:150px"
                                    ></el-input>
                                </el-form-item>
                            </p>
                            <p>
                                <el-form-item label="车主姓名" prop="ownerName">
                                    <el-input v-model="thirdLicenselyform.ownerName"></el-input>
                                </el-form-item>
                            </p>
                            <p class="apply-flexarea">
                                <el-form-item label="区域" prop="provinceId">
                                    <el-select
                                        v-model="thirdLicenselyform.provinceId"
                                        placeholder="请选择省份"
                                        @change="provinceChange(thirdLicenselyform)"
                                    >
                                        <el-option
                                            v-for="item in provinceOptions"
                                            :key="item.provinceId"
                                            :label="item.name"
                                            :value="item.provinceId"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label prop="cityId">
                                    <el-select
                                        v-model="thirdLicenselyform.cityId"
                                        placeholder="请选择市区"
                                    >
                                        <el-option
                                            v-for="item in citysOptions"
                                            :key="item.cityId"
                                            :label="item.name"
                                            :value="item.cityId"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </p>
                            <p>
                                <el-form-item label="打印状态" prop="dayinzhuangtai">
                                    <el-select
                                        v-model="thirdLicenselyform.dayinzhuangtai"
                                        placeholder="请选择打印状态"
                                    >
                                        <el-option label="已打印" value="2"></el-option>
                                        <el-option label="未打印" value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </p>
                            <p>
                                <el-form-item label="机械类型" prop="machineryType">
                                    <el-input v-model="thirdLicenselyform.machineryType"></el-input>
                                </el-form-item>
                            </p>
                            <p class="apply-flexarea">
                                <el-form-item label="出厂日期" prop="startendProductionDate">
                                    <el-date-picker
                                        style="width:300px"
                                        class="flex-rt"
                                        unlink-panels
                                        v-model="thirdLicenselyform.startendProductionDate"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                    ></el-date-picker>
                                </el-form-item>
                            </p>
                        </div>
                    </el-form>

                    <p class="flex-btn">
                        <el-button
                            type="primary"
                            icon="el-icon-search"
                            @click="handleSearch(thirdLicenselyform,'3')"
                        >搜索</el-button>
                        <el-button type="primary" icon="el-icon-document-add" class="handle-del">
                            <router-link to="/addfblicense" style="color: #fff;">添加牌照</router-link>
                        </el-button>
                        <!-- <el-button
							type="primary"
							icon="el-icon-printer"
							class="handle-del"
							@click="listPrintFileLicense(thirdLicenselyform,'3','third')"
                        >批量打印</el-button>-->
                        <el-button
                            type="primary"
                            icon="el-icon-printer"
                            class="handle-del"
                            @click="listPrintMechanicalPictures()"
                        >打印车辆图片</el-button>
                    </p>

                    <el-table
                        :data="allLicenselyTableData"
                        border
                        class="table"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
                        <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
                        <el-table-column prop="ownerCellphoneNumber" label="车主电话" align="center"></el-table-column>
                        <el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
                        <el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
                        <el-table-column prop="fuelType" label="燃油类型"></el-table-column>
                        <el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
                        <el-table-column
                            prop="applicantOrganizationName"
                            label="机构名称"
                            align="center"
                        ></el-table-column>
                        <el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>

                        <el-table-column label="操作" width="260" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-view">
									<!-- :to="'/fz_seeLicenseapplysfzorgan/'+scope.row.licenseApplyId" -->
                                    <router-link :to="`/fz_seeLicenseapplysfzorgan/${scope.row.licenseApplyId}/${activeName}/${query.pageIndex}`" style="color: #409EFF;"
                                    >查看</router-link>
                                </el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicense(thirdLicenselyform,'3',scope.row,'third')"
                                >设备档案打印</el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicenseZhengFuBen(thirdLicenselyform,'3',scope.row,'third')"
                                >登记证正副本打印</el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicenseZhengBen(thirdLicenselyform,'3',scope.row,'third')"
                                >登记证正本打印</el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicenseFuBen(thirdLicenselyform,'3',scope.row,'third')"
                                >登记证副本打印</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="query.pageIndex"
                            :page-size="query.pageSize"
                            :total="pageTotal"
                            @current-change="handlePageChange($event,thirdLicenselyform,'3')"
                        ></el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="所属区域小程序用户牌照申请展示" name="second" v-if="!isManufacturer">
                    <el-form
                        ref="secondLicenselyform"
                        :model="secondLicenselyform"
                        class="apply-flex"
                    >
                        <div class="apply-flex">
                            <!-- <p>
                                <el-form-item label="业务员" prop="applicantName">
                                    <el-input v-model="secondLicenselyform.applicantName"></el-input>
                                </el-form-item>
                            </p>-->
                            <p>
                                <el-form-item label="牌照编码" prop="equipmentCode">
                                    <el-input
                                        v-model="secondLicenselyform.equipmentCode"
                                        style="width:150px"
                                    ></el-input>
                                </el-form-item>
                            </p>
                            <p>
                                <el-form-item label="车主姓名" prop="ownerName">
                                    <el-input v-model="secondLicenselyform.ownerName"></el-input>
                                </el-form-item>
                            </p>
                            <p class="apply-flexarea">
                                <el-form-item label="区域" prop="provinceId">
                                    <el-select
                                        v-model="secondLicenselyform.provinceId"
                                        placeholder="请选择省份"
                                        @change="provinceChange(secondLicenselyform)"
                                    >
                                        <el-option
                                            v-for="item in provinceOptions"
                                            :key="item.provinceId"
                                            :label="item.name"
                                            :value="item.provinceId"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label prop="cityId">
                                    <el-select
                                        v-model="secondLicenselyform.cityId"
                                        placeholder="请选择市区"
                                    >
                                        <el-option
                                            v-for="item in citysOptions"
                                            :key="item.cityId"
                                            :label="item.name"
                                            :value="item.cityId"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </p>
                            <p>
                                <el-form-item label="打印状态" prop="dayinzhuangtai">
                                    <el-select
                                        v-model="secondLicenselyform.dayinzhuangtai"
                                        placeholder="请选择打印状态"
                                    >
                                        <el-option label="已打印" value="1"></el-option>
                                        <el-option label="未打印" value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                            </p>
                            <p>
                                <el-form-item label="机械类型" prop="machineryType">
                                    <el-input v-model="secondLicenselyform.machineryType"></el-input>
                                </el-form-item>
                            </p>
                            <p class="apply-flexarea">
                                <el-form-item label="出厂日期" prop="startendProductionDate">
                                    <el-date-picker
                                        style="width:300px"
                                        class="flex-rt"
                                        unlink-panels
                                        v-model="secondLicenselyform.startendProductionDate"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                    ></el-date-picker>
                                </el-form-item>
                            </p>
                        </div>
                    </el-form>

                    <p class="flex-btn">
                        <el-button
                            type="primary"
                            icon="el-icon-search"
                            @click="handleSearch(secondLicenselyform,'5')"
                        >搜索</el-button>
                        <!-- <el-button
							type="primary"
							icon="el-icon-printer" 
							class="handle-del"
							@click="listPrintFileLicense(secondLicenselyform,'5','second')"
                        >批量打印</el-button>-->
                        <el-button
                            type="primary"
                            icon="el-icon-printer"
                            class="handle-del"
                            @click="listPrintMechanicalPictures()"
                        >打印车辆图片</el-button>
                    </p>

                    <el-table
                        :data="allLicenselyTableData"
                        border
                        class="table"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="areaName" label="区域" align="center"></el-table-column>
                        <el-table-column prop="ownerName" label="车主姓名"></el-table-column>
                        <el-table-column prop="ownerCellphoneNumber" label="车主电话" align="center"></el-table-column>
                        <el-table-column prop="equipmentCode" label="设备编码"></el-table-column>
                        <el-table-column prop="engineNumber" label="发动机号" align="center"></el-table-column>
                        <el-table-column prop="fuelType" label="燃油类型"></el-table-column>
                        <el-table-column prop="createTimeStr" label="申请日期" align="center"></el-table-column>
                        <el-table-column prop="dayinzhuangtaiStr" label="打印状态"></el-table-column>
                        <el-table-column prop="applicantName" label="业务员姓名" align="center"></el-table-column>
                        <el-table-column label="操作" width="180" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-view">
                                   <!-- <router-link :to="'/seelicenseapplys/'+scope.row.licenseApplyId" style="color: #409EFF;">
										查看
									</router-link> -->
									
									<router-link :to="'/seelicenseapplys/'+scope.row.licenseApplyId+'/'+activeName+'/'+query.pageIndex" style="color: #409EFF;">
										查看
									</router-link>
									
                                </el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicense(secondLicenselyform,'5',scope.row,'second')"
                                >设备档案打印</el-button>
                                 <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicenseZhengFuBen(thirdLicenselyform,'3',scope.row,'third')"
                                >登记证正副本打印</el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicenseZhengBen(secondLicenselyform,'5',scope.row,'second')"
                                >登记证正本打印</el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-printer"
                                    @click="getprintFileLicenseFuBen(secondLicenselyform,'5',scope.row,'second')"
                                >登记证副本打印</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="query.pageIndex"
                            :page-size="query.pageSize"
                            :total="pageTotal"
                            @current-change="handlePageChange($event,secondLicenselyform,'5')"
                        ></el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import {
    listProvinces,
    listCitysByProvinceId,
    listLicenseApplys,
    copyPrintFileLicens,
    printFileLicense,
    printLicenseApply,
    printFileLicenseZhengBen,
    printFileMechanicalPictures,
    printFileLicenseFuBen,
    printFileLicenseZhengFuBen
} from '../api/index';
export default {
    name: 'licenseapplys',
    data() {
        return {
            val: 1, //分页页码数
            activeName: 'third',
            provinceOptions: [], //省列表
            citysOptions: [], //市列表

            secondLicenselyform: {
                // applicantName: '', //业务员
                equipmentCode: '', //牌照编码
                ownerName: '', //车主姓名
                provinceId: '',
                cityId: '',
                dayinzhuangtai: '',
                startendProductionDate: '', //出厂日期
                machineryType: '' //机械类型
            },
            thirdLicenselyform: {
                // applicantOrganizationName: '', //分支机构
                equipmentCode: '', //牌照编码
                ownerName: '', //车主姓名
                provinceId: '',
                cityId: '',
                dayinzhuangtai: '',
                startendProductionDate: '', //出厂日期
                machineryType: '' //机械类型
            },

            query: {
                pageIndex: 1,
                pageSize: 10
            }, //分页
            allLicenselyTableData: [],
            multipleSelection: [],
            editVisible: false,
            pageTotal: 0,
						isManufacturer: false, //是否为厂商业务员
        };
    },
    created() {
		this.activeName = this.$route.params.activeName
		this.query.pageIndex = this.$route.params.pageIndex
		this.isManufacturer = localStorage.getItem('role')==20
        var that = this;
        // 省
        listProvinces({}).then(res => {
            // 获取数据成功后的其他操作
            that.provinceOptions = res.data;
        });
        this.getlistLicenseApplys(this.thirdLicenselyform, '3', 1); //初始化form为全部allLicenselyform
    },
    methods: {
        // 打印车辆照片
        listPrintMechanicalPictures() {
            // 获取选中的行记录
            var photoArr = [];
            var numberArr = [];
            if (this.multipleSelection.length <= 0) {
                this.$message({
                    message: '没有选择打印项哦',
                    type: 'warning'
                });
                return false;
            }

            if (this.multipleSelection.length > 2) {
                this.$message({
                    message: '最多选择2条记录哦',
                    type: 'warning'
                });
                return false;
            }

            for (var i in this.multipleSelection) {
                if (this.multipleSelection[i].mechanicalPictures) {
                    // 机械图片:多张图片直接使用","分割
                    var tem = this.multipleSelection[i].mechanicalPictures;
                    var equipmentCode = this.multipleSelection[i].equipmentCode;
                    var temArr = tem.split(',');
                    for (var j in temArr) {
                        var photo = '/api/static' + temArr[j];
                        photoArr.push(photo);
                        numberArr.push(equipmentCode);
                    }
                }
            }

            // ceshi
            /* for(var i=1;i<=2;i++){
					var photo = 'http://www.c-lodop.com/demolist/PrintSample8.jpg';
					photoArr.push(photo);
					numberArr.push("河南A1234567890");
				} */
            // ceshi

            var photoparams = {};
            photoparams.pics = photoArr;
            photoparams.numbers = numberArr;
            printFileMechanicalPictures(photoparams);
        },
        // 省改变请求市
        provinceChange(Licenselyform) {
            Licenselyform.cityId = '';
            listCitysByProvinceId({
                provinceId: Licenselyform.provinceId
            }).then(res => {
                // 获取数据成功后的其他操作
                this.citysOptions = res.data;
            });
        },
        // 获取数据列表
        // 获取 easy-mock 的模拟数据
        // getlistLicenseApplys() {
        //     listLicenseApplys({
        //     	current: this.query.pageIndex,
        //     	size: this.query.pageSize
        //     }).then(res => {
        //         // 获取数据成功后的其他操作
        //     	this.allLicenselyTableData = res.data.records;
        //     });
        // },
        getlistLicenseApplys(form, organizationKind, current) {
            var LicenseApplyobj = {};
            if (form.startendDate) {
                form.startDate = form.startendDate[0];
                form.endDate = form.startendDate[1];
            }
            // 出产日期处理
            if (form.startendProductionDate) {
                form.startProductionDate = form.startendProductionDate[0];
                form.endProductionDate = form.startendProductionDate[1];
            }
            LicenseApplyobj = form;
            LicenseApplyobj.organizationKind = organizationKind;
            LicenseApplyobj.current = current;
            LicenseApplyobj.size = this.query.pageSize;
            listLicenseApplys(LicenseApplyobj).then(res => {
                // 获取数据成功后的其他操作
                this.allLicenselyTableData = res.data.records;
                this.pageTotal = res.data.total;
            });
        },

        handleClick(tab, event) {
            this.val = 1;
            this.secondLicenselyform = {
                // applicantName: '', //业务员
                equipmentCode: '', //牌照编码
                ownerName: '', //车主姓名
                provinceId: '',
                cityId: '',
                dayinzhuangtai: ''
            };
            this.thirdLicenselyform = {
                // applicantOrganizationName: '', //分支机构
                equipmentCode: '', //牌照编码
                ownerName: '', //车主姓名
                provinceId: '',
                cityId: '',
                dayinzhuangtai: ''
            };

            this.allLicenselyTableData = [];
            var organizationKind = '';
            if (tab.name == 'second') {
                organizationKind = 5;
            } else if (tab.name == 'third') {
                organizationKind = 3;
            }
            this.query.pageIndex = 1;
            this.getlistLicenseApplys({}, organizationKind, 1);
        },

        // 触发搜索按钮
        handleSearch(form, organizationKind) {
            this.getlistLicenseApplys(form, organizationKind, 1);
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.$message.success('删除成功');
                    this.tableData.splice(index, 1);
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.form = row;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val, form, kind) {
            this.val = val;
            console.log(val);
            console.log(form);
            console.log(form, kind), console.log(this.query);
            this.$set(this.query, 'pageIndex', val);
            this.getlistLicenseApplys(form, kind, val);
        },

        // 打印
        getprintFileLicense(form, organizationKind, row, activeName) {
            console.log(form);
            console.log(organizationKind);
            console.log(row);
            console.log(activeName);
            //row.mechanicalPictures2 = '/api/static' + row.mechanicalPictures;
            copyPrintFileLicens(row);
            printLicenseApply({
                licenseApplyIds: row.licenseApplyId
            }).then(res => {
                // 获取数据成功后的其他操作
                this.activeName = activeName;
                this.getlistLicenseApplys(form, organizationKind, this.val);
                this.$message({
                    message: res.message,
                    type: 'success'
                });
            });
        },
        // 批量打印
        listPrintFileLicense(form, organizationKind, activeName) {
            // 获取选中的行记录
            // console.log(this.multipleSelection);
            var licenseApplyId = '';
            for (var i in this.multipleSelection) {
                printFileLicense(this.multipleSelection[i]);
                if (i == 0) {
                    licenseApplyId += this.multipleSelection[i].licenseApplyId;
                } else {
                    licenseApplyId += ',' + this.multipleSelection[i].licenseApplyId;
                }
            }
            // console.log(licenseApplyId);
            printLicenseApply({
                licenseApplyIds: licenseApplyId
            }).then(res => {
                // 获取数据成功后的其他操作
                this.activeName = activeName;
                this.getlistLicenseApplys(form, organizationKind, 1);
                this.$message({
                    message: res.message,
                    type: 'success'
                });
            });
        },

        // 登记证正本打印
        getprintFileLicenseZhengBen(form, organizationKind, row, activeName) {
            printFileLicenseZhengBen(row);
            printLicenseApply({
                licenseApplyIds: row.licenseApplyId
            }).then(res => {
                // 获取数据成功后的其他操作
                this.activeName = activeName;
                this.getlistLicenseApplys(form, organizationKind, this.val);
                this.$message({
                    message: res.message,
                    type: 'success'
                });
            });
        },
// 操作证正副本打印
getprintFileLicenseZhengFuBen(form, organizationKind, row, activeName) {
            printFileLicenseZhengFuBen(row);
            printLicenseApply({
                licenseApplyIds: row.licenseApplyId
            }).then(res => {
                // 获取数据成功后的其他操作
                this.activeName = activeName;
                this.getlistLicenseApplys(form, organizationKind, this.val);
                this.$message({
                    message: res.message,
                    type: 'success'
                });
            });
        },
        // 登记证副本打印
        getprintFileLicenseFuBen(form, organizationKind, row, activeName) {
            printFileLicenseFuBen(row);
            printLicenseApply({
                licenseApplyIds: row.licenseApplyId
            }).then(res => {
                // 获取数据成功后的其他操作
                this.activeName = activeName;
                this.getlistLicenseApplys(form, organizationKind, this.val);
                this.$message({
                    message: res.message,
                    type: 'success'
                });
            });
        }
    },
    computed: {}
};
</script>


<style scoped>
.apply-flex {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
}
.apply-flex p {
    width: 25%;
    margin-right: 20px;
}

.apply-flex p.apply-flexarea .el-form-item {
    margin-right: 10px;
}
.apply-flex p.apply-flexarea {
    width: 40%;
    display: flex;
    display: -webkit-flex;
}
.apply-flex .el-form-item {
    display: flex;
    display: -webkit-flex;
}

.flex-btn {
    margin-bottom: 20px;
    text-align: right;
    border-top: 1px solid #ddd;
    padding-top: 10px;
}

.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>


<style>
.apply-flex p .el-form-item__label {
    width: 80px;
}
</style>